import { useRouter } from 'next/router';
import React from 'react';

import type { Props } from './types';

import AppErrorBoundary from 'ui/shared/AppError/AppErrorBoundary';
import HeaderAlert from 'ui/snippets/header/HeaderAlert';
import HeaderDesktop from 'ui/snippets/header/HeaderDesktop';
import HeaderMobile from 'ui/snippets/header/HeaderMobile';

import * as Layout from './components';

const LayoutDefault = ({ children }: Props) => {
  const router = useRouter();
  const searchInContent = [ '/txs', '/blocks' ].includes(router.pathname);

  return (
    <Layout.Root content={ children }>
      <Layout.Container>
        <Layout.NavBar/>
        <HeaderMobile hideSearchBar={ searchInContent }/>
        <Layout.MainArea>
          <Layout.SideBar/>
          <Layout.MainColumn searchInContent={ searchInContent }>
            <HeaderAlert/>
            <HeaderDesktop hideSearchBar={ searchInContent }/>
            <AppErrorBoundary>
              <Layout.Content>
                { children }
              </Layout.Content>
            </AppErrorBoundary>
          </Layout.MainColumn>
        </Layout.MainArea>
        <Layout.Footer/>
      </Layout.Container>
    </Layout.Root>
  );
};

export default LayoutDefault;
